import { CriteriaPatchInput } from '@frontend/data-access';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { StageInput } from '.';

export interface IntrapreneurshipState {
  currentIntrapreneurChallengeId: string;
  stagesData: StageInput[];
  criteriasData: CriteriaPatchInput[];
  saveAndExit: string;
}

export const initialState: IntrapreneurshipState = {
  currentIntrapreneurChallengeId: '',
  stagesData: [],
  criteriasData: [],
  saveAndExit: '',
};

const intrapreneurshipSlice = createSlice({
  name: 'intrapreneurship',
  initialState,
  reducers: {
    setCurrentIntrapreneurChallengeId: (
      state,
      action: PayloadAction<string>
    ) => {
      state.currentIntrapreneurChallengeId = action.payload;
    },
    setAllCriteriasData: (
      state,
      action: PayloadAction<{ criterias: CriteriaPatchInput[] }>
    ) => {
      const { criterias } = action.payload;
      state.criteriasData = criterias;
    },
    setCriteriasData: (
      state,
      action: PayloadAction<{ criteria: CriteriaPatchInput; index: number }>
    ) => {
      const { criteria, index } = action.payload;
      state.criteriasData[index] = criteria;
    },
    removeCriteriaData: (state, action: PayloadAction<number>) => {
      state.criteriasData.splice(action.payload, 1);
    },
    resetCriteriasData: (state) => {
      state.criteriasData = [];
    },
    setAllStageData: (
      state,
      action: PayloadAction<{ stages: StageInput[] }>
    ) => {
      const { stages } = action.payload;
      state.stagesData = stages;
    },
    setStagesData: (
      state,
      action: PayloadAction<{ stage: StageInput; index: number }>
    ) => {
      const { stage, index } = action.payload;
      state.stagesData[index] = stage;
    },
    removeStageData: (state, action: PayloadAction<number>) => {
      state.stagesData.splice(action.payload, 1);
    },
    resetStagesData: (state) => {
      state.stagesData = [];
    },
    setSaveAndExit: (state, action: PayloadAction<string>) => {
      state.saveAndExit = action.payload;
    },
  },
});

export const {
  setCurrentIntrapreneurChallengeId,
  setAllCriteriasData,
  setCriteriasData,
  removeCriteriaData,
  resetCriteriasData,
  setAllStageData,
  setStagesData,
  removeStageData,
  resetStagesData,
  setSaveAndExit,
} = intrapreneurshipSlice.actions;

export default intrapreneurshipSlice.reducer;
